// extracted by mini-css-extract-plugin
export var container = "thirsty-section-module--container--DgAg-";
export var image = "thirsty-section-module--image--RK0la";
export var reference = "thirsty-section-module--reference--0MMxo";
export var referenceUnderline = "thirsty-section-module--referenceUnderline--PzrPO";
export var subTitle = "thirsty-section-module--subTitle--tHHtV";
export var textContainer = "thirsty-section-module--textContainer--FqWk9";
export var title = "thirsty-section-module--title--2sP9z";